import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {},
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
    prefix: '{',
    suffix: '}',
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
